import MuiChip, { type ChipProps as MuiChipProps } from '@mui/material/Chip'
import type { ReactNode } from 'react'

export interface ChipProps
  extends Omit<MuiChipProps<'button'>, 'label' | 'color' | 'component' | 'children'> {
  /** Filled primary when on, `soft-grey` when off. */
  readonly active?: boolean
  readonly children: ReactNode
}

/** A pill button for filters and toggles. Badge is the static one. */
export function Chip({ active = false, children, ...props }: ChipProps) {
  return (
    <MuiChip
      component="button"
      type="button"
      aria-pressed={active}
      label={children}
      color={active ? 'primary' : 'default'}
      {...props}
    />
  )
}
